var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "28px",
    viewBox: "0 0 93 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn-filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 91,
    height: 26,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: -1,
    y: -1,
    width: 93,
    height: 28
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 93,
    height: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    fill: "black"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "palette/header",
    transform: "translate(-378.000000, -10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-filter",
    transform: "translate(379.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "button-bg",
    stroke: "#675C54",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.562286,8.718 L17.971286,8.718 L17.971286,10.122 L13.187286,10.122 L13.187286,12.553 L17.386286,12.553 L17.386286,13.879 L13.187286,13.879 L13.187286,18 L11.562286,18 L11.562286,8.718 Z M19.7355716,8.718 L21.3605716,8.718 L21.3605716,18 L19.7355716,18 L19.7355716,8.718 Z M23.8138573,8.718 L25.4388573,8.718 L25.4388573,16.596 L30.1578573,16.596 L30.1578573,18 L23.8138573,18 L23.8138573,8.718 Z M29.660143,8.718 L37.174143,8.718 L37.174143,10.122 L34.223143,10.122 L34.223143,18 L32.598143,18 L32.598143,10.122 L29.660143,10.122 L29.660143,8.718 Z M38.7174287,8.718 L45.3994287,8.718 L45.3994287,10.122 L40.3424287,10.122 L40.3424287,12.553 L45.0224287,12.553 L45.0224287,13.879 L40.3424287,13.879 L40.3424287,16.596 L45.4904287,16.596 L45.4904287,18 L38.7174287,18 L38.7174287,8.718 Z M47.3717143,8.718 L51.8047143,8.718 C52.8273861,8.718 53.5943784,8.93899779 54.1057143,9.381 C54.6170502,9.82300221 54.8727143,10.4383294 54.8727143,11.227 C54.8727143,11.6690022 54.807715,12.0351652 54.6777143,12.3255 C54.5477137,12.6158348 54.3960485,12.8498324 54.2227143,13.0275 C54.0493801,13.2051676 53.8782152,13.3329996 53.7092143,13.411 C53.5402135,13.4890004 53.4167147,13.5409999 53.3387143,13.567 L53.3387143,13.593 C53.4773817,13.6103334 53.6268802,13.6536663 53.7872143,13.723 C53.9475485,13.7923337 54.097047,13.9028326 54.2357143,14.0545 C54.3743817,14.2061674 54.4892139,14.4033321 54.5802143,14.646 C54.6712148,14.8886679 54.7167143,15.1919982 54.7167143,15.556 C54.7167143,16.1020027 54.7578806,16.5981644 54.8402143,17.0445 C54.9225481,17.4908356 55.0503801,17.8093324 55.2237143,18 L53.4817143,18 C53.3603804,17.8006657 53.2888811,17.5796679 53.2672143,17.337 C53.2455476,17.0943321 53.2347143,16.8603345 53.2347143,16.635 C53.2347143,16.2103312 53.2087146,15.8441682 53.1567143,15.5365 C53.1047141,15.2288318 53.0093817,14.9731677 52.8707143,14.7695 C52.732047,14.5658323 52.5435489,14.4163338 52.3052143,14.321 C52.0668798,14.2256662 51.7613829,14.178 51.3887143,14.178 L48.9967143,14.178 L48.9967143,18 L47.3717143,18 L47.3717143,8.718 Z M48.9967143,12.943 L51.6617143,12.943 C52.1817169,12.943 52.5760463,12.8195012 52.8447143,12.5725 C53.1133823,12.3254988 53.2477143,11.9550025 53.2477143,11.461 C53.2477143,11.1663319 53.2043814,10.9258343 53.1177143,10.7395 C53.0310472,10.5531657 52.9118818,10.4080005 52.7602143,10.304 C52.6085469,10.1999995 52.4352153,10.1306668 52.2402143,10.096 C52.0452134,10.0613332 51.8437154,10.044 51.6357143,10.044 L48.9967143,10.044 L48.9967143,12.943 Z",
    id: "FILTER",
    fill: "#675C54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-drop-down",
    transform: "translate(75.000000, 11.000000)",
    fill: "#675C54"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 5 5 10 0"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFilter);
export default __webpack_public_path__ + "static/media/btn-filter.f1d02b8b52f3e46bea5e09e5ea93324d.svg";
export { ForwardRef as ReactComponent };